import { computed, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Size } from '../common/types';

@Component({
  selector: 'lepi-spinner',
  imports: [CommonModule],
  template: `
    <section class="flex items-center justify-center w-full h-full">
      <span
        [ngClass]="sizeClass()"
        class="icon-[mdi--loading] animate-spin text-primary"></span>
    </section>
  `,
  styleUrl: './spinner.component.css',
})
export class Spinner {
  size = input<Size>('md');

  sizeClass = computed(() => {
    switch (this.size()) {
      case 'xs':
        return 'size-[14px]';
      case 'sm':
        return 'size-[20px]';
      case 'md':
        return 'size-[24px]';
      case 'lg':
        return 'size-[32px]';
      case 'xl':
        return 'size-[40px]';
      default:
        return 'size-[24px]';
    }
  });
}
